module.exports = __webpack_public_path__ + "static/media/recruitment.cb2fe4c0.png";